
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#009e49","d":"M0 0h900v600H0z"}}),_c('path',{attrs:{"fill":"#ef2b2d","d":"M0 0h900v300H0z"}}),_c('g',{attrs:{"transform":"translate(450 300)","fill":"#fcd116"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-100V0h50","transform":"rotate(18 0 -100)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(288)"}})])])
          )
        }
      }
    